"use client";
import React, { useEffect, useState } from "react";
import CheckedSVG from "assets/images/checked.svg";

type PropsType = {
  hospName?: String;
  vetName?: String;
  email?: String;
  careTeamId?: String;
  kitData?: any;
  setKitData?: any;
};

const CareTeamRow = ({
  hospName,
  vetName,
  email,
  careTeamId,
  setKitData,
}: PropsType) => {
  const [isChecked, setIsChecked] = useState(true);

  const onChange = (e: any, teamID: any) => {
    setIsChecked(e.target.checked);
    if (e.target.checked) {
      setKitData((prevState: { careTeamIds: any }) => ({
        ...prevState,
        careTeamIds: [...prevState.careTeamIds, teamID],
      }));
    } else {
      setKitData((prevState: { careTeamIds: any[] }) => ({
        ...prevState,
        careTeamIds: prevState.careTeamIds.filter((id) => id !== teamID),
      }));
    }
  };

  useEffect(() => {
    if (isChecked) {
      onChange({ target: { checked: true } }, careTeamId); // Trigger onChange if checkbox is default checked
    }
  }, [isChecked, careTeamId]);

  return (
    <>
      <hr className="tw-w-full lg:tw-w-[90%] tw-relative tw-pl-[40px]" />
      <div className="tw-flex tw-items-center">
        {/* values row */}
        <div className="tw-w-full lg:tw-w-[90%] tw-flex tw-gap-2 md:tw-gap-6 lg:tw-gap-12 md:tw-items-center">
          <div className="tw-w-fit">
            {isChecked ? (
              <div
                className="tw-w-4 lg:tw-w-8 tw-h-4 lg:tw-h-8 tw-bg-reddishOrange tw-flex tw-item-center"
                onClick={(e) => {
                  onChange(e, careTeamId);
                }}
              >
                <img src={CheckedSVG} alt="checked tick" />
              </div>
            ) : (
              <input
                type="checkbox"
                className="tw-w-4 lg:tw-w-8 tw-h-4 lg:tw-h-8 tw-border tw-border-black"
                defaultChecked={true}
                onChange={(e) => onChange(e, careTeamId)}
              />
            )}
          </div>
          <div className="tw-w-full tw-text-xs sm:tw-text-sm tw-flex tw-space-y-1 tw-flex-col md:tw-flex-row tw-justify-between tw-flex-wrap">
            <div className="tw-flex tw-justify-between tw-w-full md:tw-w-[33%]">
              <div className="tw-font-bold tw-w-[70%] md:tw-hidden">
                Hospital Name
              </div>
              <div className="tw-pl-1 tw-text-xs sm:tw-text-sm md:tw-text-lg lg:tw-text-xl 2xl:tw-text-2xl lg:tw-leading-6 tw-w-full ">
                {hospName ? hospName : "None"}
              </div>
            </div>
            <div className="tw-flex tw-justify-between tw-w-full md:tw-w-[33%]">
              <div className="tw-font-bold tw-w-[70%] md:tw-hidden">
                Veterinarian Name
              </div>
              <div className="tw-pl-1 tw-text-xs sm:tw-text-sm md:tw-text-lg lg:tw-text-xl 2xl:tw-text-2xl lg:tw-leading-6 tw-w-full ">
                {vetName ? vetName : "None"}
              </div>
            </div>
            <div className="tw-flex tw-justify-between tw-w-full md:tw-w-[33%]">
              <div className="tw-font-bold tw-w-[70%] md:tw-hidden">Email</div>
              <div className="tw-pl-1 tw-text-xs sm:tw-text-sm md:tw-text-lg lg:tw-text-xl 2xl:tw-text-2xl lg:tw-leading-6 tw-w-full tw-break-all ">
                {email ? email : "None"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareTeamRow;
